module.exports = __webpack_public_path__ + "img/bg_green.07c5838d.png";